import "./styles/quasar.scss";
import "@quasar/extras/material-icons/material-icons.css";

import Notify from 'quasar/src/plugins/notify/Notify.js';import QDialog from 'quasar/src/components/dialog/QDialog.js';import Dialog from 'quasar/src/plugins/dialog/Dialog.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';import Loading from 'quasar/src/plugins/loading/Loading.js';import QTimeline from 'quasar/src/components/timeline/QTimeline.js';import QTimelineEntry from 'quasar/src/components/timeline/QTimelineEntry.js';;

// To be used on app.use(Quasar, { ... })
export default {
    config: {},
    components: { QDialog, QTimeline, QTimelineEntry },    
    directives: {
        ClosePopup,
        QTimeline,
        QTimelineEntry,
        QDialog,
        Dialog,
    },
  plugins: {Loading, Notify, Dialog},
  framework: {
    plugins: ["Notify", "Loading", "Dialog"],
  },
};